import { createFileRoute } from '@tanstack/react-router'
import { RefreshCw } from 'lucide-react'
import { PageHeader } from '@/components/page-header'
import { Button } from '@/components/ui/button'
import { useDashboard } from '@/features/dashboard/api'
import { CustomizeDashboardDialog } from '@/features/dashboard/customize-dialog'
import { DashboardView } from '@/features/dashboard/dashboard-view'
import { presentSections } from '@/features/dashboard/present-sections'
import { QuickActions } from '@/features/dashboard/quick-actions'
import { useCurrentEmployee } from '@/lib/auth'
import { currentTimeZone, formatIsoDate, formatTime } from '@/lib/dates'

export const Route = createFileRoute('/_app/dashboard')({
  component: DashboardPage,
})

/** Horas que delimitan el saludo (en la zona de la institución). */
const AFTERNOON_START_HOUR = 12
const EVENING_START_HOUR = 19

function greeting(): string {
  const hour = Number(new Intl.DateTimeFormat('en-US', { hour: 'numeric', hour12: false, timeZone: currentTimeZone() }).format(new Date()))
  if (hour < AFTERNOON_START_HOUR) return 'Buenos días'
  if (hour < EVENING_START_HOUR) return 'Buenas tardes'
  return 'Buenas noches'
}

function DashboardPage() {
  const employee = useCurrentEmployee()
  const { data, isLoading, error, refetch, isFetching } = useDashboard()
  const firstName = employee?.fullName.split(/\s+/)[0]
  const visible = employee?.preferences.dashboardWidgets

  return (
    <div className="space-y-8">
      <PageHeader
        eyebrow={data?.asOf ? formatIsoDate(data.asOf, 'long') : undefined}
        title={`${greeting()}${firstName ? `, ${firstName}` : ''}`}
        description={data?.generatedAt ? `Datos actualizados a las ${formatTime(data.generatedAt)}` : 'Resumen de su trabajo de hoy'}
        actions={
          <>
            <CustomizeDashboardDialog available={presentSections(data)} visible={visible} />
            <Button variant="ghost" size="icon" onClick={() => void refetch()} disabled={isFetching} aria-label="Actualizar panel">
              <RefreshCw className={isFetching ? 'animate-spin' : undefined} />
            </Button>
          </>
        }
      />
      <QuickActions />
      <DashboardView data={data} isLoading={isLoading} error={error} onRetry={() => void refetch()} visibleSections={visible} />
    </div>
  )
}
